import { on } from '@ember/modifier';
import Component from '@glimmer/component';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import SubmitButtonComponent from 'webapp/components/submit-button';

import type InfolayerItem from 'webapp/models-custom/infolayer-item/general';

interface Args {
	model: InfolayerItem;
	onClose: () => void;
}

export default class InfolayerTypeGeneralComponent extends Component<Args> {
	get actionButtonTheme() {
		return this.args.model.actionButton?.theme || 'white-outlined-red';
	}
	<template>
		<div role="button" class="infolayer {{@model.classes}}" {{on "click" @onClose}}>
			<div>
				<p>{{{@model.text}}}</p>

				{{#if @model.actionButton}}
					<br />
					<SubmitButtonComponent
						@text={{@model.actionButton.text}}
						@onTrigger={{@model.actionButton.onClick}}
						@theme={{this.actionButtonTheme}}
					/>
				{{/if}}
				<CommonUiIconComponent @name="Close" @size="sm" @class="infolayer-close" />
			</div>
		</div>
	</template>
}
